import React from 'react';
import { Link } from 'react-router-dom';

export default function Signup() {
  const handleSignup = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const response = await fetch("https://jivangaming.in/backend/signup.php", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.status === "success") {
      alert("Signup successful!");
      localStorage.setItem("user", JSON.stringify(result.user));
      localStorage.setItem("userEmail", result.user.email);
      window.location.href = "/profile"; 
    } else {
      alert(result.message || "Signup failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Create Account</h2>
        <form onSubmit={handleSignup}>

          <input name="name" placeholder="Name" required className="border p-2 w-full" />
          <input name="email" type="email" placeholder="Email" required className="border p-2 w-full" />
          <input name="password" type="password" placeholder="Password" required className="border p-2 w-full" />
          <button type="submit" className="bg-black text-white px-4 py-2 w-full">Signup</button>
        </form>

        <p className="text-center text-sm mt-4">
          Already have an account?{" "}
          <Link to="/login" className="text-blue-500">Login</Link>
        </p>
      </div>
    </div>
  );
}
